import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { AllDealershipsDTO, ErrorDTO } from '../../dto'
import { store } from '../../store'
import { BASE_ACTIONS, BASE_METHODS } from '../base/base.constants'
import { createCall } from '../base'
import { GET_DEALERSHIPS_ACTIONS } from './dealerships.constants'

export const getAllDealerships = async () => {
    store.dispatch({ type: GET_DEALERSHIPS_ACTIONS.GET_DEALERSHIPS_STARTED })

    const promise = createCall(`dealerships/all`, true, BASE_METHODS.GET)
    promise
        .then(async (response) => {
            let body: AllDealershipsDTO

            try {
                body = plainToClass(AllDealershipsDTO, JSON.parse(await response.text()))
            } catch (exception) {
                store.dispatch({ type: BASE_ACTIONS.ERROR_INVALID_JSON })
                return
            }

            if ((await validate(body)).length > 0) {
                store.dispatch({ type: BASE_ACTIONS.ERROR_INVALID_RESPONSE })
                return
            }

            store.dispatch({ type: GET_DEALERSHIPS_ACTIONS.GET_DEALERSHIPS_OK, dealerships: body.dealerships, page: 1, pageSize: 15, count: body.dealerships.length })

            store.dispatch({ type: BASE_ACTIONS.CLEAR_ERROR })
        })
        .catch(async (response) => {
            let error: ErrorDTO

            try {
                error = plainToClass(ErrorDTO, JSON.parse(await response.text()))
            } catch (exception) {
                //store.dispatch({ type: response })
                return
            }

            store.dispatch({ type: GET_DEALERSHIPS_ACTIONS.GET_DEALERSHIPS_FAILED })

            store.dispatch({ type: BASE_ACTIONS.ERROR_MESSAGE, message: error.message, code: error.code })
        })
}
